/**
 * Obiekt reprezentujący stany odpowiedzi w kontekście Internet of Things (IoT).
 * Zawiera różne kody stanów i ich opisy.
 * @enum {number}
 */
const IoTResponseStatus = {
    /**
     * Brak statusu. Nie powinno się zdarzyć.
     * @type {number}
     */
    NO_STATUS: 0,

    /**
     * Odebrane przez bramkę. Bramka przyjęła komendę do realizacji.
     * @type {number}
     */
    RECEIVED_BY_GATEWAY: 1,

    /**
     * Sukces. Bramka lub urządzenie odpowiedziało sukcesem.
     * @type {number}
     */
    SUCCESS: 2,

    /**
     * Błąd parsera komendy. Przychodząca komenda jest niepoprawna.
     * @type {number}
     */
    REQUEST_PARSER_ERROR: 3,

    /**
     * Komenda odrzucona. Urządzenie końcowe odrzuciło komendę.
     * @type {number}
     */
    COMMAND_REJECTED: 4,

    /**
     * Brak odpowiedzi od urządzenia. Timeout odpowiedzi fizycznego urządzenia.
     * @type {number}
     */
    NO_RESPONSE_FROM_DEVICE: 5,

    /**
     * Dane niegotowe. Zapytanie o `state` urządzenia, które nie ma pełnych danych.
     * @type {number}
     */
    DATA_NOT_READY: 6,

    /**
     * Błąd parsera odpowiedzi. Nie udało się sparsować odpowiedzi z fizycznego urządzenia.
     * @type {number}
     */
    RESPONSE_PARSER_ERROR: 7,

    /**
     * no idea lol
     * @type {number}
     */
    UNKNOWN_PIG: 8,

    /**
     * no idea lol
     * @type {number}
     */
    UNKNOWN_PIG_CONFIG: 9,

    /**
     * Komenda nieznana. Brak obsługi danej komendy.
     * @type {number}
     */
    COMMAND_UNKNOWN: 10,

    /**
     * Brak uprawnień. Użytkownik nie jest uprawniony do wykonania tej komendy.
     * @type {number}
     */
    UNAUTHORIZED: 11,

    /**
     * Urządzenie końcowe jest aktualnie w trakcie karmienia (dotyczy tylko karmienia).
     * @type {number}
     */
    DEVICE_CURRENTLY_FEEDING: 12,

    /**
     * Urządzenie jest zajęte.
     * @type {number}
     */
    DEVICE_BUSY: 13,

    /**
     * Błąd urządzenia w bieżącym czasie. Zbyt duże przeciążanie silnika (dotyczy tylko karmienia).
     * @type {number}
     */
    DEVICE_ERROR_CURRENT: 14,

    /**
     * Urządzenie offline. Wysyłane z automatu, zamiast NO_RESPONSE_FROM_DEVICE, gdy urządzenie zostaje oznaczone jako offline na bramce.
     * @type {number}
     */
    DEVICE_OFFLINE: 15,

    /**
     * no idea lol
     * @type {number}
     */
    DEVICE_UNKNOWN_ON_MULTI: 16
};

module.exports = IoTResponseStatus;
